import request from '@/utils/http'

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

// 查询
export const search = (keyword,pageNo,pageSize) => {
    return request.requestGet(BASE_URL+"portal/articleSearch/search/"+keyword+"/"+pageNo+"/"+pageSize);
};
